export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MC4yOCAxODkuMTYiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMTE5O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoICBkPSJNNjQuNTguODguMjYsMTA3Ljg5YTEuOCwxLjgsMCwwLDAsMS41NSwyLjczSDQwLjE3YTEuOCwxLjgsMCwwLDEsMS43NSwyLjIxbC0xNy4xLDc0LjExYTEuOCwxLjgsMCwwLDAsMy4zMSwxLjMyTDkwLDgzLjYyYTEuOCwxLjgsMCwwLDAtMS41NS0yLjcySDUxLjgzYTEuODEsMS44MSwwLDAsMS0xLjc2LTIuMjJMNjcuODgsMi4yMkExLjgsMS44LDAsMCwwLDY0LjU4Ljg4WiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bolt.svg
// module id = 383
// module chunks = 0 5